export var listItemContentMediaStyles = {
  root: function root(_ref) {
    var v = _ref.variables;
    return {
      fontSize: v.contentMediaFontSize,
      lineHeight: v.contentMediaLineHeight
    };
  }
};